import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <img src="https://rmlocation.re/wp-content/uploads/2025/11/cropped-RM-Location-3-1-e1730841979378.png"
                alt="RM Location Prestige" className="h-14 w-auto brightness-150"
                onError={e => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }} />
              <div style={{display:'none'}}>
                <span className="text-white text-xl font-bold">RM Location</span>
                <span className="text-[#D4A843] text-xs font-medium tracking-widest ml-2">Prestige</span>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-gray-400 mb-5 max-w-xs">
              Location de Porsche Macan avec chauffeur pour mariages à La Réunion. Élégance, ponctualité et service irréprochable.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com" target="_blank" rel="noreferrer"
                className="w-9 h-9 bg-gray-800 flex items-center justify-center hover:bg-[#D4A843] transition-colors">
                <Facebook size={16} />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noreferrer"
                className="w-9 h-9 bg-gray-800 flex items-center justify-center hover:bg-[#D4A843] transition-colors">
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">Navigation</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                ["Accueil", "/"],
                ["Porsche Macan", "/vehicules"],
                ["Disponibilités", "/disponibilites"],
                ["Réserver", "/reservation"],
                ["Services", "/#services"],
                ["À propos", "/#about"],
                ["Contactez-nous", "/#contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  {to.startsWith("/#") ? (
                    <a href={to} className="hover:text-[#D4A843] transition-colors">{label}</a>
                  ) : (
                    <Link to={to} className="hover:text-[#D4A843] transition-colors">{label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={14} className="text-[#D4A843] mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:0692042073" className="hover:text-[#D4A843] transition-colors block">0692 04 20 73</a>
                  <span className="text-xs text-gray-500">Devis urgent — 7j/7</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={14} className="text-[#D4A843] mt-0.5 flex-shrink-0" />
                <a href="mailto:contact@rmlocation.re" className="hover:text-[#D4A843] transition-colors break-all">contact@rmlocation.re</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-[#D4A843] mt-0.5 flex-shrink-0" />
                <span>La Réunion, France<br /><span className="text-xs text-gray-500">Service sur toute l'île</span></span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800 px-4 py-5">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} RM Location Prestige. Tous droits réservés.</span>
          <span>Location de Porsche Macan pour mariages à La Réunion</span>
        </div>
      </div>
    </footer>
  );
}
